import { showAlert } from '../../utils/Alert'
import { extractJrTrains, extractTokyuTrains } from '../../utils/TrainExtractor'
import {
  fetchTrains,
  fetchJrTrains,
  fetchTokyuPresignedUrl,
  fetchPresignedJson,
  fetchShinyokohamaTrainInfo,
  fetchUserSettings,
  receiveTrainPosition,
  receiveJrTrainPosition,
  receiveTokyuTrainPosition,
  receiveShinyokohamaTrainInfo,
  receiveUserSettings,
} from '../../actions'

/**
 * 新横浜駅でK番号の列車が含まれている場合、shinyokohama_train_info APIを呼び出して情報を補完する
 */
const fetchKTrainInfos = async (trains, dispatch) => {
  for (const train of trains) {
    const match = train.train_number?.match(/^K([0-9]+)/)
    if (match) {
      try {
        const payload = await fetchShinyokohamaTrainInfo(Number(match[1]))
        dispatch(receiveShinyokohamaTrainInfo(payload, Number(match[1])))
      } catch (error) {
        showAlert('新横浜駅在線情報が取得できませんでした')
      }
    }
  }
}

/**
 * 各コンテナで共通して使用するアクションクリエイターを生成
 */
export const createCommonActionCreators = (dispatch) => ({
  fetchTrains: async () => {
    try {
      const payload = await fetchTrains()
      dispatch(receiveTrainPosition(payload))
      await fetchKTrainInfos(payload.trains, dispatch)
      return payload.trains
    } catch (error) {
      showAlert('相鉄線在線情報が取得できませんでした')
    }
  },

  fetchJrTrains: async () => {
    try {
      const payload = await fetchJrTrains()
      dispatch(receiveJrTrainPosition(payload))
      if (payload.error && payload.error === 'U10002') return []
      if (payload.uj_proxy_result !== 0 || payload.resultCode !== 'I00001') return []
      return extractJrTrains(payload)
    } catch (error) {
      showAlert('JR線在線情報が取得できませんでした')
      return []
    }
  },

  fetchTokyuTrains: async (lineSymbol) => {
    try {
      const signedUrl = await fetchTokyuPresignedUrl(lineSymbol)
      const payload = await fetchPresignedJson(signedUrl.url)
      dispatch(receiveTokyuTrainPosition(payload, lineSymbol))
      return extractTokyuTrains(payload.trains)
    } catch (error) {
      showAlert(`東急線在線情報${lineSymbol}が取得できませんでした`)
      return []
    }
  },

  fetchUserSettings: async (popinfoId) => {
    try {
      if (!popinfoId) {
        return true
      }
      const payload = await fetchUserSettings(popinfoId)
      dispatch(receiveUserSettings(payload))
    } catch (error) {
      showAlert('設定を取得できませんでした')
    }
  },
})
